import { render } from "./expand-icon.vue?vue&type=template&id=5a389a33"
import script from "./expand-icon.vue?vue&type=script&lang=js"
export * from "./expand-icon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__